const getters = {
    TOOLS: ({ tools }) => tools,
    TOOL: ({ tool }) => tool,
    WORKFLOW_TOOL: ({ tool }) => tool.WorkflowTool,
    FETCH_TOOLS_LOADING: ({ fetchToolsLoading }) => fetchToolsLoading,
    DELETE_TOOL_LOADING: ({ deleteToolsLoading }) => deleteToolsLoading,
}

export default getters